import {
  AppContext,
  DATE_FORMAT_MMM_DD_YYYY,
  TIME_FORMAT_HH_MM_A,
  getCalendarFormats
} from '@nile/components';
import dayjs from 'dayjs';
import React, { useContext } from 'react';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import calendar from 'dayjs/plugin/calendar';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);

const DateTimeFormatter = (props) => {
  const { type, date, relative } = props;

  const context = useContext(AppContext);

  const renderFormattedDateTime = () => {
    const { dateFormat, timeFormat, timezoneCode } =
      props?.company || context?.company || context?.companyInfo || {};
    switch (type) {
      // To do - use date instead of onlyDate
      case 'date':
      case 'onlyDate':
        return dayjs(date).format(dateFormat || DATE_FORMAT_MMM_DD_YYYY);
      case 'time':
        return dayjs(date).format(timeFormat || TIME_FORMAT_HH_MM_A);
      case 'dateTime':
        return dayjs(date).format(
          `${dateFormat || DATE_FORMAT_MMM_DD_YYYY} ${timeFormat ||
            TIME_FORMAT_HH_MM_A}`
        );
      case 'fromNowUTC':
        return dayjs.tz(date, 'utc').fromNow();
      case 'fromNow':
        return dayjs.tz(date, timezoneCode).fromNow();
      case 'toTechTimeZone':
        return dayjs(`${new Date(date)} GMT`)
          .utc()
          .tz(timezoneCode)
          .format(
            `${dateFormat || DATE_FORMAT_MMM_DD_YYYY} ${timeFormat ||
              TIME_FORMAT_HH_MM_A}`
          );
      default:
        return 'Invalid date';
    }
  };

  if (relative) {
    const relativeFormattedDate = dayjs(date).calendar(
      undefined,
      getCalendarFormats(type, renderFormattedDateTime)
    );
    const displayRelativeDate =
      relativeFormattedDate.toLowerCase() === 'invalid date'
        ? 'NA'
        : relativeFormattedDate;

    return <span title={displayRelativeDate}>{displayRelativeDate}</span>;
  }

  const formattedDate = renderFormattedDateTime();
  const displayDate =
    formattedDate.toLowerCase() === 'invalid date' ? 'NA' : formattedDate;

  return <span title={displayDate}>{displayDate}</span>;
};

export default DateTimeFormatter;
